// Google AdSense configuration.
// Fill these in AFTER AdSense approves the site, then redeploy:
//   1) ADSENSE_CLIENT = "ca-pub-XXXXXXXXXXXXXXXX"  (your publisher ID)
//   2) AD_SLOTS.scoreRail = "1234567890"           (an ad-unit slot ID you create)
// Until ADSENSE_CLIENT + a slot are set, <AdSlot> renders nothing (no empty boxes).
// The loader <script> in index.html is also gated on this and must use the same client ID.
export const ADSENSE_CLIENT = "ca-pub-9438345527762668";
export const AD_SLOTS = {
  scoreRail: "", // set after approval: create a responsive display ad unit and paste its slot ID here
};
